import { Key, useCallback, useEffect, useState } from "react";
import { StyleSheet } from "../../StyleSheet";
import { Button, Card, Col, Divider, Row, Typography } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import { useDispatch, useSelector } from "react-redux";
import { fillGeneralDataSlice, getGeneralData, setUpdateAlias } from "../../stores/slices/generalDataSlice";
import { addAssociatedC, getSuscriptorData, removeAssociatedC, updateAliasAssociated } from "../../methods/Methods";
import _ from "lodash";
import { RequestAliasClientAssociated, RequestAsociarContrato, RequestDesasociarContrato, ResponseSuscriptorDataGeneralDatum } from "../../types/common";
import { AlertSliceInterface, clearAlert, setAlert, showAlert } from "../../stores/slices/alertSlice";
import { AppDispatch } from "../../stores/store";
import AddContract from "./components/AddContract";
import Loading from "../../components/Loading";
import EditContract from "./components/EditContract";
import RemoveContract from "./components/RemoveContract";
const { Text } = Typography;

const AssociatedContracts = () => {
    const [showElement, setShowElement] = useState<Key>();
    const generalData = useSelector(getGeneralData);
    const [idCliente, setIdCliente] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [editAssociatedC, setEditAssociatedC] = useState(false);
    const [deleteAssociatedC, setDeleteAssociatedC] = useState(false);
    const [listOfAssociatedC, setListOfAssociatedC] = useState<Array<ResponseSuscriptorDataGeneralDatum>>([]);
    const [isReset, setIsReset] = useState(false);
    const dispatch = useDispatch<AppDispatch>();
    const handleDispatchAlertModal = useCallback(() => {
        dispatch(showAlert(false));
        dispatch(clearAlert());
    }, [dispatch]);

    // Manejador para el alert
    const openAlertModal = useCallback((option: AlertSliceInterface) => {
        dispatch(setAlert({
            show: option.show,
            type: option.type as "INFO" | "SUCCESS" | "ERROR",
            title: option.title,
            message: option.message,
            onFinalize: option.onFinalize
        }));
    }, [dispatch]);

    const getSuscriptor = useCallback(async () => {
        setIsLoading(true);
        await getSuscriptorData(idCliente)
            .then((response) => {
                if (response.data && response.data[0]) {
                    setListOfAssociatedC(response.data[0].generalData);
                }
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
            });
    }, [idCliente]);

    const handlePress = (key: Key) => {
        if (key === "addContract") {
            setShowElement(showElement === "addContract" ? "" : key);
        } else {
            setShowElement(key === showElement ? "" : key);
            setEditAssociatedC(false);
            setDeleteAssociatedC(false);
        }
    };

    const handleCancelEdit = () => {
        setEditAssociatedC(false);
    };

    const handleCancelRemove = () => {
        setDeleteAssociatedC(false);
    };

    const addContract = (objAddContract: RequestAsociarContrato) => {
        let typeStatus = "";
        setIsLoading(true);
        addAssociatedC(objAddContract, idCliente)
            .then((response) => {
                if (response.data.data[0].estatus && response.data.data[0].estatus !== "Error") {
                    dispatch(fillGeneralDataSlice({
                        clientId: idCliente
                    }))
                    typeStatus = "SUCCESS";
                } else {
                    typeStatus = "ERROR";
                }
                let dispatchAlert: AlertSliceInterface = {
                    show: true,
                    type: typeStatus as "INFO" | "SUCCESS" | "ERROR",
                    title: "¡Estimado Usuario!",
                    message: response.data.data[0].mensaje,
                    onFinalize: () => handleDispatchAlertModal()
                }
                openAlertModal(dispatchAlert);
                // para que se cierre el card de añadir contrato
                setShowElement(undefined);
                setIsLoading(false);
            })
            .catch(() => {
                let dispatchAlert: AlertSliceInterface = {
                    show: true,
                    type: "ERROR",
                    title: "¡Estimado Usuario!",
                    message: "Hubo un error al asociar el contrato. \nIntente más tarde.",
                    onFinalize: () => handleDispatchAlertModal()
                }
                openAlertModal(dispatchAlert);
                setIsLoading(false);
            })
    };

    const handleEdit = (alias: string, suscriptorToUpdate: string, isAssociatedC: boolean) => {
        if (isAssociatedC) {
            let objUpdate: RequestAliasClientAssociated = {
                alias: alias,
                idCliente: suscriptorToUpdate
            }
            let typeStatus = "";
            setIsLoading(true);
            updateAliasAssociated(objUpdate, idCliente)
                .then(async (response) => {
                    if (response.data && response.data.data && response.data.data[0] && response.data.data[0].status) {
                        typeStatus = "SUCCESS";
                        dispatch(setUpdateAlias({
                            idCliente: objUpdate.idCliente,
                            alias: objUpdate.alias,
                            action: "UPDATE"
                        }));
                    } else {
                        typeStatus = "ERROR";
                    }
                    let dispatchAlert: AlertSliceInterface = {
                        show: true,
                        type: typeStatus as "INFO" | "SUCCESS" | "ERROR",
                        title: "¡Estimado Usuario!",
                        message: response.data.data[0].message,
                        onFinalize: () => handleDispatchAlertModal()
                    }
                    setEditAssociatedC(false);
                    // para que se cierre el card
                    setShowElement(undefined);
                    openAlertModal(dispatchAlert);
                    setIsLoading(false);
                })
                .catch(() => {
                    let dispatchAlert: AlertSliceInterface = {
                        show: true,
                        type: "ERROR",
                        title: "¡Estimado Usuario!",
                        message: "Hubo un error al actualizar el contrato asociado. \nIntente más tarde.",
                        onFinalize: () => handleDispatchAlertModal()
                    }
                    openAlertModal(dispatchAlert);
                    setIsLoading(false);
                })
        }
    };

    const handleRemove = useCallback((sucursal: string, suscriptor: string) => {
        let objRemove: RequestDesasociarContrato = {
            sucursalAsociado: sucursal,
            suscriptorAsociado: suscriptor
        }
        let typeStatus = "";
        let messageStatus = "";
        setIsLoading(true);
        removeAssociatedC(objRemove, idCliente)
            .then(async (response) => {
                if (response.data.data[0].estatus && response.data.data[0].estatus === "Exito") {
                    dispatch(setUpdateAlias({
                        idCliente: objRemove.sucursalAsociado + objRemove.suscriptorAsociado,
                        alias: "",
                        action: "DELETE"
                    }));
                    typeStatus = "SUCCESS"
                    messageStatus = "El contrato " + objRemove.sucursalAsociado + objRemove.suscriptorAsociado + " ha sido desasociado correctamente.";
                } else {
                    typeStatus = "ERROR"
                    messageStatus = "Error al desasociar contrato. \nIntente más tarde.";
                }
                let dispatchAlert: AlertSliceInterface = {
                    show: true,
                    type: typeStatus as "INFO" | "SUCCESS" | "ERROR",
                    title: "¡Estimado Usuario!",
                    message: messageStatus,
                    onFinalize: () => handleDispatchAlertModal()
                }
                openAlertModal(dispatchAlert);
                // para que se cierre el card
                setShowElement(undefined);
                setIsReset(true);
                setIsLoading(false);
            })
            .catch(() => {
                let dispatchAlert: AlertSliceInterface = {
                    show: true,
                    type: "ERROR",
                    title: "¡Estimado Usuario!",
                    message: "Hubo un error al desasociar el contrato. \nIntente más tarde.",
                    onFinalize: () => handleDispatchAlertModal()
                }
                openAlertModal(dispatchAlert);
                setIsLoading(false);
            })
    }, [dispatch, handleDispatchAlertModal, idCliente, openAlertModal]);

    useEffect(() => {
        if (!_.isEmpty(idCliente)) {
            getSuscriptor();
        }
    }, [idCliente, getSuscriptor]);

    useEffect(() => {
        if (generalData.selectedContract !== null) {

            setIdCliente(
                generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor
            );
            setDeleteAssociatedC(false);
            setEditAssociatedC(false);
            setShowElement(undefined);
        }
    }, [generalData.selectedContract]);

    useEffect(() => {
        if (generalData) {
            setListOfAssociatedC(generalData.contracts)
        }
    }, [generalData]);

    return (
        <>
            {
                isLoading ?
                    <Loading />
                    :
                    <SubDefaultLayout title={"Contratos Asociados"} >
                        <div style={styles.divRoot}>
                            {
                                !_.isEmpty(listOfAssociatedC) ?
                                    listOfAssociatedC
                                        .filter(item => {
                                            const contractId = item.sucursal + item.suscriptor;
                                            return contractId !== idCliente;
                                        })
                                        .map((item, index) => (
                                            <Card key={index} style={styles.cardStyles}>
                                                <Row style={{ cursor: 'pointer' }} onClick={() => handlePress(index)}>
                                                    <Col span={20} style={styles.titleContainer}>
                                                        <Text style={styles.titleContract}>{"Contrato " + (index + 1)}</Text>
                                                        <Text style={styles.subtitleContract}>{item.sucursal + item.suscriptor}</Text>
                                                    </Col>
                                                    <Col span={4} style={styles.colView}>
                                                        {(index === showElement) ? (
                                                            <UpOutlined style={styles.iconStyles} />
                                                        ) : (
                                                            <DownOutlined style={styles.iconStyles} />
                                                        )}
                                                    </Col>
                                                </Row>
                                                {(index === showElement) && (
                                                    <div style={{ marginTop: 20 }}>
                                                        {
                                                            editAssociatedC ?
                                                                <EditContract item={item} handleCancel={handleCancelEdit} handleEdit={handleEdit} />
                                                                :
                                                                deleteAssociatedC ?
                                                                    <RemoveContract item={item} handleCancel={handleCancelRemove} handleRemove={handleRemove} isReset={isReset} />
                                                                    :
                                                                    <>
                                                                        <Row justify={"center"}>
                                                                            <Col style={styles.containerData}>
                                                                                <Text style={styles.inputTextName}>{item.nombre + " " + item.apellidoPaterno + " " + item.apellidoMaterno}</Text>
                                                                                <Divider style={styles.lineDivider} />
                                                                                <Text style={styles.inputTitle}>Suscriptor</Text>
                                                                                <Text style={styles.inputText}>{item.sucursal + item.suscriptor}</Text>
                                                                                <Divider style={styles.lineDivider} />
                                                                                <Text style={styles.inputTitle}>Número Exterior</Text>
                                                                                <Text style={styles.inputText}>{item.numeroExterior}</Text>
                                                                                <Divider style={styles.lineDivider} />
                                                                                <Text style={styles.inputTitle}>Alias de Contrato</Text>
                                                                                <Text style={styles.inputText}>{item.alias}</Text>
                                                                            </Col>
                                                                        </Row>
                                                                        <div style={styles.containerButtons}>
                                                                            <Button
                                                                                size='large'
                                                                                style={styles.buttonPrimary}
                                                                                onClick={() => setEditAssociatedC(true)}
                                                                            >
                                                                                {"Editar"}
                                                                            </Button>
                                                                            {
                                                                                item.isAssociatedContract ?
                                                                                    <Button
                                                                                        size='large'
                                                                                        style={styles.buttonPrimary}
                                                                                        onClick={() => setDeleteAssociatedC(true)}
                                                                                    >
                                                                                        {"Desasociar"}
                                                                                    </Button>
                                                                                    : null
                                                                            }

                                                                        </div>
                                                                    </>
                                                        }
                                                    </div>
                                                )}
                                            </Card>
                                        ))
                                    : null
                            }
                            <AddContract showElement={showElement} handlePress={handlePress} addContract={addContract} />
                        </div>
                    </SubDefaultLayout>
            }
        </>
    );
};

const styles = StyleSheet.create({
    divRoot: {
        alignItems: 'center',
        display: 'flex',
        width: "100%",
        flexDirection: 'column',
        marginTop: 20
    },
    cardStyles: {
        marginBottom: 15,
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 15,
        width: "70%",
    },
    titleContainer: {
        display: "flex",
        flexDirection: 'column',
    },
    containerData: {
        display: "flex",
        flexDirection: 'column',
        alignItems: 'center'
    },
    containerButtons: {
        display: "flex",
        flexDirection: 'row',
        justifyContent: 'center',
        marginTop: 20
    },
    iconStyles: {
        fontSize: 20,
        color: "#767a82"
    },
    titleContract: {
        fontWeight: 'bold',
        fontSize: "1.50em",
        color: "#0055c1"
    },
    subtitleContract: {
        fontWeight: 600,
    },
    addContract: {
        fontWeight: 600,
        color: "#757982",
        fontSize: 17,
    },
    colView: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    inputTitle: {
        color: "black",
        fontWeight: 600
    },
    inputTextName: {
        marginTop: 3,
        color: "#000000",
    },
    inputText: {
        marginTop: 3,
        color: "#0055c2",
        fontWeight: 'bold'
    },
    lineDivider: {
        backgroundColor: '#0055b9',
        margin: "5px 0"
    },
    buttonPrimary: {
        backgroundColor: '#0055c2',
        borderRadius: 30,
        color: 'white',
        border: "none",
        padding: "5px 30px",
        height: 35,
        marginLeft: 20,
        marginRight: 20
    },
});

export default AssociatedContracts;
